import React, { useState } from "react";
import { Modal, Button, Input } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import uuid from "react-uuid";
import { useDispatch, useSelector } from "react-redux";
import { setModalVisible } from "../../../../redux/actions/templates/AddSection";
import {
  setAddSection,
  setFooterValue,
  setSectionDetails,
} from "../../../../redux/actions/section/section";
import {
  setIsSelected,
  setupdatedGraphData,
  setWidgetList,
} from "../../../../redux/actions/widget/widget";
import {
  setClearGraphDetails,
  setWelcomePage,
} from "../../../../redux/actions/dashboard/Welcome";
import { deepCopy, getPaneIndex } from "../../../../redux/constants";
import { setAllSelectedCheckbox } from "../../../../redux/actions/widget/widget";
import { setOptionHighChart } from "../../../../redux/actions/HighChart";
import { setWidgetMetaData } from "../../../../redux/actions/WidgetMaker/WidgetAPI";
import {
  setWidgetLibraryCheckedList,
  setWidgetLibraryFilter,
} from "../../../../redux/actions/WidgetMaker/WidgetLibrary";

const AddDetail = (props, { setIsSaveTemplate }) => {
  const { TextArea } = Input;
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const footerValue = useSelector((state) => state.Section.footerValue);
  const sectionDetails = useSelector((state) => state.Section.sectionDetails);
  const Section = useSelector((state) => state.Section.addSection);
  const widgetList = useSelector((state) => state.Widget.widgetList);

  const [name, setname] = useState("");
  const [isAddSection, setIsAddSection] = useState(false);
  const [description, setdescription] = useState(null);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const [flag, setflag] = useState(false);
  const panes = useSelector((state) => state.Tab1.panes);
  const activeKey = useSelector((state) => state.Tab1.activeKey);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const predefined_widgets_data = useSelector(
    (state) => state.WidgetAPI.predefined_widgets_data?.data
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const [oldSectionName, setOldSectionName] = useState();
  const widgetLibrarycheckedList = useSelector(
    (state) => state.WidgetLibrary.widgetLibrarycheckedList
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const handleChange = (e) => {
    setname(e.target.value);

    var oldSection;
    Section?.forEach((oldData, i) => {
      let oldName = oldData?.name?.toLowerCase();
      let evn = e.target.value;
      let newName = evn?.toLowerCase();

      if (oldName == newName) {
        oldSection = newName;
        setOldSectionName(newName);
      }
    });

    if (!oldSection) {
      setflag(false);
      setOldSectionName("");
    } else {
      setflag(true);
    }
  };

  const handleCancel = () => {
    dispatch(setModalVisible(false));
    setIsAddSection(false);
  };

  const handleSave = (id) => {
    setIsAddSection(true);

    if (name?.trim().length !== 0 && !oldSectionName) {
      if (footerValue?.section) {
        let pageInsightCheck =
          widgetLibrarycheckedList?.length > 0
            ? predefined_widgets_data?.findIndex((el) =>
                widgetLibrarycheckedList?.includes(el?.widget_id)
              )
            : -1;
        if (footerValue?.widgetMaker && pageInsightCheck === -1) {
          const sectionValue = Section.find((el) => el.id === id);
          let widgetObj = {
            widget_id: widgetLibrarycheckedList,
            is_section: true,
            sectionValue: sectionValue,
            name: name,
            description: description,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            templateDetails: templateDetails,
            Section: Section,
            graphConditionConfig: graphConditionConfig,
            addWidget: true,
          };
          dispatch(setWidgetMetaData(authParams, widgetObj));
        } else {
          const sectionValue = Section.find((el) => el.id === id);
          let deepCopyOfPredefined_widgets_data = predefined_widgets_data
            ? deepCopy(predefined_widgets_data)
            : predefined_widgets_data;
          let predefinedWidgetsArray = [];
          Array.isArray(widgetLibrarycheckedList) &&
            widgetLibrarycheckedList?.forEach((id) => {
              let indOfWidget = deepCopyOfPredefined_widgets_data?.findIndex(
                (el) => el?.widget_id === id
              );
              if (indOfWidget !== -1) {
                predefinedWidgetsArray?.push(
                  deepCopyOfPredefined_widgets_data?.[indOfWidget]
                );
              }
            });
          let section = [
            {
              id: sectionValue?.id ? sectionValue?.id : uuid(),
              name: sectionValue?.name ? sectionValue?.name : name?.trim(),
              description: sectionValue?.description
                ? sectionValue?.description
                : description?.trim(),
              isSectionAdded: true,
              isWidgetAdded: true,
              data: sectionValue?.data
                ? predefinedWidgetsArray?.length > 0
                  ? [...predefinedWidgetsArray, ...sectionValue?.data]
                  : [...widgetList, ...sectionValue?.data]
                : predefinedWidgetsArray?.length > 0
                ? predefinedWidgetsArray
                : widgetList,
            },
          ];

          let newObj = {
            templateDetails: templateDetails,
            newSection: true,
            authParams: authParams,
            global_brands: templateDetails?.templateBrands
              ? templateDetails?.templateBrands
              : null,
            brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            global_duration: templateDetails?.templateDuration
              ? templateDetails?.templateDuration
              : null,
            global_filters: templateDetails?.templateFilters
              ? templateDetails?.templateFilters
              : [],
            graphConditionConfig: graphConditionConfig,
          };

          dispatch(setAddSection(Section, section, false, newObj));
        }

        dispatch(setWidgetList([]));
        dispatch(setWidgetLibraryCheckedList([]));
        dispatch(setupdatedGraphData({}));
        dispatch(setIsSelected({}));
      }

      // for Redirect
      if (
        sectionDetails?.sectionKey === "CreateTemplate" &&
        !footerValue?.dashboard
      ) {
        // history.push(`/create-dashboard`, { addSection: false });
        // PIN DEV On back section save to create-dashboard
        history.goBack();
        dispatch(
          setSectionDetails({
            sectionKey: "CreateTemplate",
            isSectionAdded: true,
          })
        );
        dispatch(
          setFooterValue({ section: false, widget: false, template: true })
        );
        // setTimeout(()=>{
        //   window?.scrollTo(0, document?.body?.scrollHeight);
        // },500)
      } else if (sectionDetails?.sectionKey === "edit_template") {
        let index = getPaneIndex(panes, activeKey);
        let template_id = panes[index]?.template_id;
        // history.push(`/edit-dashboard/${template_id}`, {
        //   addSection: false,
        // });
        // PIN DEV On back section save to edit-dashboard
        history.goBack();
        dispatch(
          setFooterValue({ section: false, widget: false, template: true })
        );
        // setTimeout(()=>{
        //   window?.scrollTo(0, document?.body?.scrollHeight);
        // },500)
      } else if (sectionDetails?.sectionKey === "") {
        // history.push(`/dashboard`, { onGraphPage: false });
        // PIN DEV sectionDetails?.sectionKey empty
        history.goBack();
        dispatch(
          setFooterValue({ section: false, widget: false, template: false })
        );
      }

      dispatch(setOptionHighChart(null));
      dispatch(setModalVisible(false));
      dispatch(setClearGraphDetails());
      dispatch(setAllSelectedCheckbox(false));
      dispatch(setWelcomePage(true));

      let filterObj = {
        search_text: "",
        pill: "All Widgets",
        offset: 0,
        no_of_rows: 12,
        sort_expression: "created_date",
        sort_order: "desc",
        chart_type: "",
        attribute: "",
      };
      dispatch(setWidgetLibraryFilter(filterObj));

      dispatch({ type: "SET_WIDGET_LIBRARY_LIST", payload: null });
    } else {
    }

    const timer = setTimeout(() => {
      let scrollToBottom = document.documentElement.scrollHeight;
      window.scrollBy(0, scrollToBottom);
    }, 200);
    return () => {
      clearTimeout(timer);
    };
  };

  return (
    <Modal
      title={
        <div className="portlet__title fontSize-16 font-weight500">
          {footerValue?.section
            ? "Enter Section Details"
            : "Enter Widget Details"}
        </div>
      }
      visible={props?.isAddDetail}
      onCancel={handleCancel}
      footer={[
        <Button
          type="button"
          className="btn_Clear"
          style={{ minWidth: "5.6rem" }}
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>,
        <Button
          type="primary"
          className="ant-btn-primary_blue"
          onClick={() => handleSave(location?.state?.id)}
        >
          Save
        </Button>,
      ]}
      width={580}
      maskClosable={false}
      bodyStyle={{ padding: "1.5rem" }}
      className={authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"}
    >
      <>
        <div className="floating-label-group AddDetail">
          <Input
            className="inputFiled"
            type="text"
            required
            maxLength={50}
            value={name}
            onChange={handleChange}
          />
          <span
            className="text-gray position-absolute font-size12"
            style={{ bottom: "1rem", right: "0.5rem" }}
          >
            {name?.length > 0 ? name?.length : 0}/50
          </span>
          <label className="customAttribute__filterSubtitle floating-label">
            {footerValue?.section ? (
              <>
                Section Name <span className="error">*</span>
              </>
            ) : (
              <>
                Widget Name <span className="error">*</span>
              </>
            )}
          </label>
        </div>
        {isAddSection && name?.trim().length === 0 ? (
          <p className="error font-size12">Section name is required</p>
        ) : flag ? (
          <p className="error font-size12">Section name is already exist</p>
        ) : (
          ""
        )}
        <div
          className={`floating-label-group AddDetail mt-15 mb-15 ${
            footerValue?.widget ? "d-none" : ""
          }`}
        >
          <TextArea
            maxLength={150}
            required
            onChange={(e) => setdescription(e.target.value)}
            style={{ resize: "none" }}
            rows={3}
          />
          <span
            className="text-gray position-absolute font-size12"
            style={{ bottom: "0.2rem", right: "0.5rem" }}
          >
            {description?.length > 0 ? description?.length : 0}/150
          </span>
          <label className="customAttribute__filterSubtitle floating-label">
            Section Description
          </label>
        </div>
      </>
    </Modal>
  );
};

export default AddDetail;
